// extracted by mini-css-extract-plugin
module.exports = {"projectList":"ProjectList-module--projectList--1IKGL"};